import * as actionTypes from './actionTypes';
import constants from "../../utils/constants";

const log = require("loglevel").getLogger("fundsReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	funds: null,
	lastUpdated: null
});

function fundsReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case constants.GLOBAL_ACTION_INIT_STATE: {
			log.debug("reset program state");
			return initialState;
		}
		case actionTypes.FUND_LOADED: {
			const loadedFund = action.data;
			let {funds} = state;
			const index = (funds || []).findIndex(f => f.Id === loadedFund.Id);

			if(index > -1) {
				funds[index] = loadedFund;
			}
			else {
				funds = [loadedFund];
			}

			return {
				...state,
				funds
			};
		}
		case actionTypes.FUNDS_LOADED: {
			return {
				...state,
				funds: action.data,
				lastUpdated: action.lastUpdated
			};
		}
		default:
			return state;
	}
}

export default fundsReducer;
